


































export default function (Component) {
  Component.options.__source = "src/module/components/lolth-explorer/filter/cmp-text-floating-filter.vue"
}
